var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-brand"},[_c('img',{staticClass:"product-brand-img",attrs:{"src":_vm.$storageUrl + _vm.imagePath,"alt":_vm.title}})])
}
var staticRenderFns = []

export { render, staticRenderFns }